
import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';


const BScPhysicsCoursePage: React.FC = () => {
  const courseData = {
    title: "B.Sc. Physics",
    shortName: "B.Sc. Physics",
    duration: "3 years",
    description: "Study of matter, energy, and fundamental forces of nature",
    overview: "Bachelor of Science in Physics is a 3-year undergraduate program that provides comprehensive understanding of fundamental principles governing the physical world. This course covers classical mechanics, quantum physics, thermodynamics, electromagnetism, and modern physics, preparing students for careers in research, teaching, technology, and various industries requiring analytical and problem-solving skills.",
    eligibility: [
      "10+2 with Physics, Chemistry, Mathematics",
      "Minimum 60% marks in science subjects",
      "Strong mathematical aptitude",
      "Interest in scientific research and experimentation"
    ],
    curriculum: [
      {
        year: 1,
        subjects: [
          "Mechanics and Properties of Matter",
          "Heat and Thermodynamics",
          "Mathematics for Physics",
          "Chemistry",
          "Computer Programming",
          "General English"
        ]
      },
      {
        year: 2,
        subjects: [
          "Electricity and Magnetism",
          "Waves and Optics",
          "Modern Physics",
          "Mathematical Physics",
          "Electronics",
          "Environmental Science"
        ]
      },
      {
        year: 3,
        subjects: [
          "Quantum Mechanics",
          "Solid State Physics",
          "Nuclear and Particle Physics",
          "Astrophysics",
          "Practical Physics",
          "Project Work"
        ]
      }
    ],
    careerProspects: {
      roles: [
        "Research Scientist",
        "Physics Teacher/Professor",
        "Data Scientist",
        "Quality Control Analyst",
        "Technical Writer",
        "Software Developer",
        "Meteorologist",
        "Medical Physicist",
        "Astronomer",
        "Instrumentation Engineer"
      ],
      industries: [
        "Research Institutions",
        "Educational Institutions",
        "Aerospace Industry",
        "Defense Organizations",
        "Technology Companies",
        "Healthcare Sector",
        "Energy Sector",
        "Manufacturing Industries",
        "Government Laboratories",
        "Space Research"
      ],
      averageSalary: "₹3-7 LPA (Fresher), ₹12-30 LPA (Experienced)",
      topRecruiters: [
        "ISRO, DRDO, BARC",
        "IITs, IISc, TIFR",
        "Infosys, TCS, Wipro",
        "Google, Microsoft, IBM",
        "Nuclear Power Corporation",
        "Educational Institutions"
      ]
    },
    admissionProcess: [
      "Merit-based admission on 12th marks",
      "University entrance examinations",
      "JEE Main scores (for some colleges)",
      "Online application and counseling",
      "Document verification"
    ],
    topColleges: [
      {
        name: "University of Madras",
        location: "Chennai",
        fees: "₹25,000",
        ranking: "State University"
      },
      {
        name: "Loyola College",
        location: "Chennai",
        fees: "₹65,000",
        ranking: "NIRF Ranking: 15"
      },
      {
        name: "Presidency College",
        location: "Chennai",
        fees: "₹20,000",
        ranking: "Government College"
      },
      {
        name: "PSG College of Arts and Science",
        location: "Coimbatore",
        fees: "₹55,000",
        ranking: "NAAC A+ Grade"
      }
    ],
    skills: [
      "Analytical Thinking",
      "Mathematical Modeling",
      "Laboratory Techniques",
      "Data Analysis",
      "Problem Solving",
      "Computer Programming",
      "Research Methodology",
      "Technical Writing",
      "Instrumentation",
      "Statistical Analysis"
    ],
    futureScope: "Excellent opportunities in emerging fields like quantum computing, renewable energy, space technology, artificial intelligence, and medical physics with growing emphasis on research and innovation.",
    faqs: [
      {
        question: "What career options are available after B.Sc. Physics?",
        answer: "Graduates can pursue research, teaching, data science, software development, quality control, technical writing, or further studies like M.Sc., M.Tech, or MBA."
      },
      {
        question: "Can physics graduates work in IT companies?",
        answer: "Yes, physics graduates are highly valued in IT for their analytical skills, problem-solving abilities, and mathematical background, especially in data science and software development."
      },
      {
        question: "What are the research opportunities in physics?",
        answer: "Research opportunities exist in theoretical physics, experimental physics, astrophysics, quantum physics, materials science, and interdisciplinary fields at universities and research institutions."
      },
      {
        question: "Is B.Sc. Physics good for competitive exams?",
        answer: "Yes, physics provides excellent foundation for competitive exams like UPSC, banking, railways, and entrance tests for higher studies due to strong analytical and quantitative skills."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0a183d] via-black to-[#1a2746] flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow animate-glow mb-8 text-center">
        {courseData.title}
      </h1>
      <div className="w-full max-w-5xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BScPhysicsCoursePage;
